import { Modal } from "antd";

/**
 * Asks before throwing away what has been typed.
 *
 * The old Cancel opened a Bootstrap modal through `data-toggle`, which only
 * worked because the button sat inside a wrapper carrying those attributes —
 * so the click did nothing once the markup changed. This owns the behaviour
 * rather than depending on the markup around it.
 */
export function confirmDiscard(onDiscard: () => void, isEdit = false) {
  Modal.confirm({
    title: isEdit ? "Leave without saving?" : "Discard this fund?",
    content: isEdit
      ? "Any changes you have made will be lost."
      : "Everything entered so far will be lost.",
    okText: isEdit ? "Leave" : "Discard",
    okButtonProps: { danger: true },
    cancelText: "Keep editing",
    centered: true,
    onOk: onDiscard,
  });
}
